import React, {memo} from 'react';

import {findTimeZone} from '../../../src/helpers/dateTimeHelpers';
import {DateFormat} from '../../internationalization/dateFormat';

/*
 * Props.
 */

export interface DateTimeFormatterBaseProps {
  value: Date;
  format: Intl.DateTimeFormatOptions;
}

/*
 * Component.
 */

export const DateTimeFormatterBase = memo<DateTimeFormatterBaseProps>(({value, format}) => (
  <DateFormat value={value} format={{...format, timeZone: findTimeZone()}} />
));
